import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { utilBuff } from "../../../utils/utilBuff";
import { actionPlayerInfoBuffExpire, TypeActionPlayerInfo, } from "./actionPlayerInfo";
export var epicPlayerInfoOnAddBuff = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.AddBuff), switchMap(function (action) {
        var buff = action.buff;
        if (!buff || buff.length === 0) {
            return EMPTY;
        }
        var actions = [];
        var groupedByRemainingTime = utilBuff.groupByRemainingTime(buff);
        Object.keys(groupedByRemainingTime).forEach(function (key) {
            if (key != undefined) {
                var remainingTime = parseInt(key, 10);
                if (remainingTime > 0) {
                    var buffs = groupedByRemainingTime[key];
                    actions.push(actionPlayerInfoBuffExpire(buffs, remainingTime));
                }
            }
        });
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player/epicPlayerInfoOnAddBuff.ts
// module id = 1930
// module chunks = 3